import React from 'react';

interface Props {
    text: string;
    filepath: string;
}

const DownloadFileLink: React.FC<Props> = ({
    text,
    filepath
}) => {
    return (
        <div>
            <a href={ filepath } download>
                { text }
            </a>
        </div>
    );
};

export default DownloadFileLink;